import { useIntl } from '@weenat/wintl';
import { useClient } from '../../ClientProvider';
import { OrgRole } from '../../enums';
import schemas from '../../schemas';
import useMutation from '../../useMutation';
import useQuery from '../../useQuery';
import useOrderedFields from '../useOrderedFields';
const schema = schemas.members.updateRole;
export const useEditMember = ({ member, useToasts, onSuccess, formRef }) => {
    const { t } = useIntl();
    const client = useClient();
    const { addToast } = useToasts();
    const myEmail = useQuery(client.me.get()).data?.email;
    const isMe = myEmail === member.email;
    const isOwnerMember = member.role === OrgRole.owner;
    const shouldShowCanNotEditText = isMe || isOwnerMember;
    const [updateRole, updateRoleRequest] = useMutation(client.members.updateRole(member.id), {
        onSuccess: () => {
            addToast(t('models.member.actions.edit_success', {
                value: member.name
            }), { appearance: 'success' });
            onSuccess?.();
        },
        keysToInvalidate: [client.members.get(member.id).invalidationKey]
    });
    const isDisabled = shouldShowCanNotEditText || updateRoleRequest.isPending;
    const fieldProps = useOrderedFields(['role'], formRef, {
        shared: { isDisabled }
    });
    const roleOptions = [OrgRole.viewer, OrgRole.agent, OrgRole.admin].map((role) => ({
        label: t(`roles.${role}`),
        value: role
    }));
    const props = {
        form: {
            schema,
            onSubmit: ({ role }) => updateRole({ role }),
            initialValues: { role: member.role }
        },
        field: {
            ...fieldProps,
            role: {
                ...fieldProps.role,
                options: roleOptions,
                label: t('models.member.actions.select_role_label')
            }
        },
        submitButton: {
            isDisabled: isDisabled,
            isSuccess: updateRoleRequest.isSuccess,
            isLoading: updateRoleRequest.isPending,
            isError: updateRoleRequest.isError
        },
        canNotEditText: {
            children: isMe
                ? t('models.member.actions.you_can_not_edit_yourself')
                : isOwnerMember
                    ? t('models.member.actions.you_can_not_edit_owner')
                    : null
        }
    };
    const shouldShow = {
        canNotEditText: shouldShowCanNotEditText
    };
    return { shouldShow, props };
};
